import React from "react";
import { FaEllipsisV, FaAngleRight } from "react-icons/fa";
import "./InfoCard.css";

const InfoCard = ({
  title = "Paramètres généraux",
  count = 0,
  unit = "documents",
  Icon,
  options = [],
  actionType = "Ajouter",
  onClick,
  onStatsClick,
  showOptions = true, 
}) => {
  return (
    <div className="info-card border rounded-4 shadow-sm p-3 bg-white h-100 d-flex flex-column">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2 mb-2 mb-sm-0 info-card-title">
          {Icon && <Icon className="card-icon flex-shrink-0" />}
          <h6 className="m-0 fw-semibold flex-grow-1">{title}</h6>
        </div>

        {/* Dropdown menu — show only if enabled */}
        {showOptions && (
          <div className="dropdown">
            <button
              className="btn btn-link p-0 text-muted"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <FaEllipsisV />
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              {options.length > 0 ? (
                options.map((opt, idx) => (
                  <li key={idx}>
                    <button className="dropdown-item" onClick={opt.onClick}>
                      {opt.label}
                    </button>
                  </li>
                ))
              ) : (
                <li>
                  <span className="dropdown-item text-muted">
                    Aucune option
                  </span>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>

      {/* Main Value */}
      <h2
        className="fw-normal mb-3 ms-2 text-break text-center text-md-start"
        onClick={onStatsClick}
        style={{ color: "rgba(77, 100, 102, 1)", cursor: "pointer" }}
      >
        {count.toLocaleString("fr-CH")}{" "}
        <small className="fs-6 text-muted">{unit}</small>
      </h2>

      {/* Footer Action */}
      {onClick && (
        <div className="mt-auto pt-2">
          <hr className="w-100 my-1" />
          <div className="d-flex align-items-center justify-content-end pe-2">
            <button
              onClick={onClick}
              className="action-btn btn btn-sm fw-semibold"
            >
              {actionType}
            </button>
            <FaAngleRight
              className="ms-2"
              style={{ color: "rgba(239, 67, 70, 1)" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoCard;
